export default "__VITE_ASSET__C_I6j$px__"